import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  /* Resetando margens, paddings e definindo box-sizing */
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  /* Definindo a fonte padrão do corpo */
  body {
    font-family: 'Roboto', sans-serif;
    background-color: #f4f7fa; /* Fundo neutro claro e moderno */
    color: #333;
    line-height: 1.6;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-size: 16px; /* Tamanho base de texto */
  }

  /* Melhorando links */
  a {
    text-decoration: none;
    color: #007bff; /* Azul corporativo */
    transition: color 0.3s ease;
  }

  a:hover {
    color: #0056b3; /* Azul mais escuro para hover */
  }

  /* Estilo para títulos */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Arial', sans-serif;
    font-weight: bold;
    color: #333; /* Cor mais sóbria para títulos */
    margin-bottom: 1rem;
  }

  /* Estilos para botões */
  button {
    cursor: pointer;
    background-color: #0066cc; /* Azul vibrante para botões */
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 4px;
    font-size: 16px;
    transition: background-color 0.3s ease, transform 0.2s ease;
  }

  button:hover {
    background-color: #005bb5; /* Tom mais escuro do azul */
    transform: scale(1.05);
  }

  button:focus {
    outline: 2px solid #004a99; /* Azul mais forte para foco */
  }

  /* Estilizando listas */
  ul, ol {
    list-style: none;
  }

  /* Estilizando campos de entrada */
  input, textarea, select {
    font-family: 'Roboto', sans-serif;
    border: 1px solid #ccc; /* Cor mais suave para bordas */
    border-radius: 4px;
    padding: 8px;
    outline: none;
    transition: border-color 0.3s ease;
    width: 100%;
  }

  /* Foco nos campos de entrada */
  input:focus, textarea:focus, select:focus {
    border-color: #0066cc; /* Azul claro para foco */
  }

  /* Container geral */
  .container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
  }

  /* Grid layout */
  .grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
  }

  /* Estilo para cabeçalho */
  header {
    background-color: #003366; /* Azul escuro e sóbrio para o cabeçalho */
    color: white;
    padding: 20px 0;
    text-align: center;
  }

  /* Estilo para rodapé */
  footer {
    background-color: #f1f1f1; /* Cinza claro para o rodapé */
    color: #333;
    padding: 20px 0;
    text-align: center;
  }

  /* Responsividade */
  @media (max-width: 768px) {
    body {
      font-size: 14px; /* Menor fonte para dispositivos móveis */
    }
    .container {
      padding: 10px;
    }
  }

  /* Responsividade para o grid */
  @media (max-width: 576px) {
    .grid {
      grid-template-columns: 1fr; /* Um item por linha em dispositivos muito pequenos */
    }
  }
`;

export default GlobalStyle;
